<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
		[ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<app-loader *ngIf="!dataIsLoaded"></app-loader>
<section class="main-side-nav" *ngIf="dataIsLoaded"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container my-delegates-container dynamic-grid-container" id="dynamicGridContainer">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>My Plan <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Delegates'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Delegates</h1>
				<input type="button" class="col-auto btn btn-primary primary-default-btn" value="Add A Delegate"
					(click)="add()">
			</div>
		</section>

		<section>
			<section class="no-items">
				<div class="desktop-explanation dynamic-explanation"
					[ngClass]="statusExplanations ? 'explanationDesktopCollapsed' : '' ">
					<div class="container">
						<div class="closing-help-btn" (click)="statusExplanations = !statusExplanations">
							<img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
						</div>
						<app-delegate-empty-state [ngClass]="statusExplanations ? 'explanationDesktopCollapsed' : '' ">
						</app-delegate-empty-state>
					</div>
				</div>

				<div class="mobile-explanation dynamic-explanation"
					[ngClass]="statusExplanations ? 'explanationMobileCollapsed' : '' ">
					<div class="container">
						<div class="closing-help-btn" (click)="statusExplanations = !statusExplanations">
							<img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
						</div>
						<app-delegate-empty-state [ngClass]="statusExplanations ? 'explanationMobileCollapsed' : '' ">
						</app-delegate-empty-state>
					</div>
				</div>
			</section>
		</section>

		<ng-container>
			<div class="notification-bubble-container">
				<app-notification-bubble></app-notification-bubble>
			</div>
			<section class="delegates-section">
				<section class="delegate-list">
					<div class="delegate-explanation-mobile-container">
						<app-delegate-explanation-mobile></app-delegate-explanation-mobile>
					</div>

					<div class="delegates-suggested-sections">
						<section class="dynamic-collapse">
							<div class="professional-delegate"
								*ngIf="(companyDetails && companyDetails.hideSponsor != true) && professionalIsDelegate==false && companyDetails.firstName">
								<div>
									<i class="fa fas fa-info"></i>
								</div>
								<div class="message">Make your advisor at {{companyName}} a delegate
								</div>
								<input type="button" value="Add" (click)="addProfessionalAsDelegate(companyDetails)">
							</div>
							<div class="title-dynamic-section">
								Your Delegates
							</div>
							<div class="info-container" *ngIf="!myItemList">
								<div class="no-delegate">No delegates added yet</div>
								<div class="info" (click)="statusExplanations = !statusExplanations">
									<div class="info-text">Learn About delegates</div>
									<div class="svg-container help-btn-svg-container">
										<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
											width="30px" viewBox="0 0 832.46 905">

											<path
												d="M821.24,842.05c-44.62,44.62-84.61,78-137.16,98.8-19.58,7.77-49.17,13.79-69.47,18-122.82,25.39-256.92-6-379.44-128.5C92.46,687.62,88.24,383,243.16,235.21,420.63,65.87,665.57,92.86,821.24,248.53,983.08,410.37,983.08,680.21,821.24,842.05Z"
												transform="translate(-110.16 -62)" opacity="0.3" />
											<path
												d="M794.26,774.53c-44,44-83.44,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73-140.74-140.73-144.9-441.1,7.89-586.89,175-167,416.57-140.38,570.08,13.14C953.86,348.82,953.86,614.93,794.26,774.53Z"
												transform="translate(-110.16 -62)" class="svg-background" />
											<g>
												<path
													d="M617.21,321.54c-12.72-21.24-39.49-47.33-94.76-51.09-60.22-4.11-106.7,26-130.89,84.73-2.86,6.94-1.31,14.32,4.36,20.78,9.39,10.7,29.86,18.15,38.28,15.91,9-2.41,13.66-10.09,18.56-18.21,5.4-9,12.11-20.11,27.08-29.81,16.56-10.75,36.57-8.07,47-5.52,18.75,4.58,31.32,13.94,34.26,19.12,6.75,11.89,9.8,44.62-26.93,83.39-29.61,31.28-44.63,65.83-44.63,102.71v34.87c0,6.94,4.1,12.62,11.26,15.58,4.57,1.9,10.82,2.68,17.38,2.68,13.7,0,28.77-3.43,32.68-7.34.16-.16.28-.25.37-.33,4.08-3.34,3.66-7.08,3.32-10.09-.39-3.45-1.41-12.61-1.41-37.17,0-25.35,15.47-43.86,33.39-65.3,12.51-15,25.46-30.47,34.17-49.82C636.46,391.68,635.11,351.41,617.21,321.54Z"
													transform="translate(-110.16 -62)" class="svg-sign" />
												<path
													d="M531.23,622.46c-16.81-2.08-32.75,5.89-39.67,19.83-6.83,13.77-6.67,28.4.45,40.14a35,35,0,0,0,29.3,17.08h1.49c9.78,0,26.12-2,36.06-14.09,4.76-5.78,9.67-16.18,6-32.94C561.33,636.1,548.43,624.59,531.23,622.46Z"
													transform="translate(-110.16 -62)" class="svg-sign" />
											</g>
										</svg>
									</div>
								</div>
							</div>
							<ng-container *ngIf="myItemList">
								<ng-container *ngFor="let item of myItemList; let i=index">
									<section class="dynamic-collapse-header-toggle" (click)="collapsed[i]=!collapsed[i]"
										[ngClass]="collapsed[i] ? 'dynamic-collapse-header-collapsed' : ''">
										<div class="ovale ovale-registered" *ngIf="item.registered">Registered</div>
										<div class="ovale ovale-registered" *ngIf="!item.registered">Not Registered Yet
										</div>
										<h3>{{item.itemName}} <span
												class="relation-delegate">[{{item.delegateRelation}}]</span></h3>
										<div class="delegates-manage-buttons" (click)="toggleActions(i)">
											<div class="edit-btn" [ngClass]="{'show-actions': openedIndex === i}">
												<input type="button" class="btn btn-primary primary-sml-btn"
													(click)="edit(item.Id); $event.stopPropagation()" value="edit">
												<i class="fa fas fa-pencil-alt"></i>
											</div>

											<div class="delete-btn" [ngClass]="{'show-actions': openedIndex === i}">
												<input type="button" class="btn btn-primary primary-sml-btn"
													(click)="callDialog(item.Id,item.itemName); $event.stopPropagation()" value="Delete">
												<i class="fa fas fa-trash"></i>
											</div>
										</div>

										<div class="chevron-down">
											<img src="../../assets/img/{{themeService.theme}}/top-arrow.svg"
												[ngClass]="collapsed[i] ? 'chevron-collapsed' : ''">
										</div>
									</section>
									<section class="dynamic-collapse-main"
										[ngClass]="collapsed[i] ? 'dynamic-collapse-main-collapsed' : ''">
										<section class="dynamic-collapse-content">
											<div class="category-rights">
												<div class="category">Assets</div>
												<app-delegate-rights
													[rights]="item.assetsPermission"></app-delegate-rights>
											</div>
											<div class="category-rights">
												<div class="category">Debts</div>
												<app-delegate-rights
													[rights]="item.debtsPermission"></app-delegate-rights>
											</div>
											<div class="category-rights">
												<div class="category">Daily Life</div>
												<app-delegate-rights
													[rights]="item.dailyLifePermission"></app-delegate-rights>
											</div>
											<div class="category-rights">
												<div class="category">Digital Life</div>
												<app-delegate-rights
													[rights]="item.digitalLifePermission"></app-delegate-rights>
											</div>
											<div class="category-rights">
												<div class="category">Wishes</div>
												<app-delegate-rights
													[rights]="item.wishesPermission"></app-delegate-rights>
											</div>
											<div class="last-update">
												Last updated by {{item.lastUpdateByName}} on
												{{item.lastUpdate | date: 'dd/MM/yyyy'}}
											</div>
										</section>
									</section>
								</ng-container>
							</ng-container>
						</section>
						<div class="suggested-delegates">
							<div class="title-dynamic-section"
								*ngIf="availableDelegatesRelations && availableDelegatesRelations.length > 0">
								Suggested Delegates
							</div>

							<div *ngIf="availableDelegatesRelations && availableDelegatesRelations.length > 0">
								<div *ngFor="let relation of availableDelegatesRelations; let i = index">
									<app-suggested-delegates [relation]="relation"
										(removeSuggestion)="removeDelegateRelation(i)"></app-suggested-delegates>
								</div>
								<div class="show-more" *ngIf="showMore">
									<div class="see-suggestions">See more suggestions</div>

									<img src="../../assets/img/default/top-arrow.svg" alt=""
										(click)="showAllDelegatesRelations()">
								</div>
								<div class="show-less" *ngIf="showLess">
									<img src="../../assets/img/default/top-arrow.svg" alt=""
										(click)="showShortListOfDelegatesRelations()">
								</div>
							</div>
						</div>
					</div>

					<div class="delegate-explanation">
						<app-delegate-explanation></app-delegate-explanation>
					</div>
				</section>
			</section>
		</ng-container>
		<app-dialog [visible]="showDialog" [itemName]="itemNameforDialog" [sectionName]="sectionTitle"
			(dialogAnswer)="deleteByEvent($event)">
		</app-dialog>
	</section>
</section>